import { render, staticRenderFns } from "./MaterialStatsCardDetail.vue?vue&type=template&id=3d6fc207&scoped=true"
import script from "./MaterialStatsCardDetail.vue?vue&type=script&lang=js"
export * from "./MaterialStatsCardDetail.vue?vue&type=script&lang=js"
import style0 from "./MaterialStatsCardDetail.vue?vue&type=style&index=0&id=3d6fc207&prod&scoped=true&lang=css"
import style1 from "./MaterialStatsCardDetail.vue?vue&type=style&index=1&id=3d6fc207&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6fc207",
  null
  
)

export default component.exports